import { type DeviceEntity } from '@solinkcorp/api-types';

export function getAccessibleAddress(
  device: {
    deviceUrl: DeviceEntity['deviceUrl'];
    deviceLocalUrl: DeviceEntity['deviceLocalUrl'];
    /**
     * CH Device data's deviceUrl is relay 1 URL but camera data's deviceUrl is relay 2 URL.
     * So deviceUrlV2 is not required.
     */
    deviceUrlV2?: DeviceEntity['deviceUrlV2'];
  },
  locationIsLocal: boolean | undefined,
): string | null {
  if (locationIsLocal && device.deviceLocalUrl) {
    return device.deviceLocalUrl;
  }

  return device.deviceUrlV2 ?? device.deviceUrl;
}
